/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.bluetooth = {};

    function bluetooth_varDef(a, b) {
        var c = "SoftwareSerial bt_serial(" + b + ", " + a + ");";
        0 == b && 1 == a && (c = "HardwareSerial &bt_serial=Serial;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n");
        /* Arduino Mega no implemented
        "Arduino Mega" == profile["default"].description &&
        (19 == b && 18 == a && (c = "HardwareSerial &bt_serial=Serial1;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"),
         17 == b && 16 == a && (c = "HardwareSerial &bt_serial=Serial2;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"),
         15 == b && 14 == a && (c = "HardwareSerial &bt_serial=Serial3;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"));
         */
        return c
    }
    function setupBluetooth() {
        Blockly.Arduino.definitions_.define_softserial = "#include <SoftwareSerial.h>\n";
        Blockly.Arduino.definitions_.var_bluetooth || (Blockly.Arduino.definitions_.var_bluetooth = bluetooth_varDef(2, 3));
        Blockly.Arduino.setups_.setup_bluetooth || (Blockly.Arduino.setups_.setup_bluetooth = "  bt_serial.begin(9600);\n");
    }
    Blockly.Arduino.bluetooth_init = function() {
        var a = this.getFieldValue("BAUD"),
            b = this.getFieldValue("RX"),
            c = this.getFieldValue("TX");
        setupBluetooth();
        Blockly.Arduino.definitions_.var_bluetooth = bluetooth_varDef(b, c);
        Blockly.Arduino.setups_.setup_bluetooth = "bt_serial.begin(" + a + ");\n";
        return ""
    };
    Blockly.Arduino.bluetooth_init2 = function() {
        var a = this.getFieldValue("BAUD");
        Blockly.Arduino.definitions_.var_bluetooth = "HardwareSerial &bt_serial=Serial;";
        Blockly.Arduino.setups_.setup_bluetooth = "bt_serial.begin(" + a + ");\n";
        return ""
    };
    Blockly.Arduino.bluetooth_name_simple = function() {
        var a = this.getFieldValue("VERSION");
        setupBluetooth();
        Blockly.Arduino.definitions_fnc_.fnc_bt_serial_namepin =
        'void fnc_bt_serial_name(String _name) {\n'             +
        '  delay(2000);\n'                                      +
        '  bt_serial.println(String("AT+NAME=") + _name);\n'    +
        '  delay(1000);\n'                                      +
        '  while(bt_serial.available() > 0) bt_serial.read();\n'+
        '  bt_serial.flush();\n}\n\n';
        a = Blockly.Arduino.valueToCode(this, "DEVNAME", Blockly.Arduino.ORDER_ATOMIC) || "'HelloBlocks'";
        return "fnc_bt_serial_name(" + a + ");\n"
    };
    Blockly.Arduino.bluetooth_timeout = function() {
        setupBluetooth();
        return "bt_serial.setTimeout(" + Blockly.Arduino.valueToCode(this, "MS", Blockly.Arduino.ORDER_ATOMIC) + ");\n"
    };
    Blockly.Arduino.bluetooth_print = function() {
        setupBluetooth();
        var a = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "''";
        return "TRUE" == this.getFieldValue("NEWLINE") ? "bt_serial.println(" + a + ");\n" : "bt_serial.print(" + a + ");\n"
    };
    Blockly.Arduino.bluetooth_println = function() {
        setupBluetooth();
        return "bt_serial.println(" + (Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "''") + ");\n"
    };
    Blockly.Arduino.bluetooth_write_byte = function() {
        setupBluetooth();
        return "bt_serial.write((byte)" + (Blockly.Arduino.valueToCode(this, "BYTE", Blockly.Arduino.ORDER_ATOMIC) || "0") + ");\n"
    };
    Blockly.Arduino.bluetooth_read_float = function() {
        setupBluetooth();
        return ["TRUE" == this.getFieldValue("NEWLINE") ? "atof((bt_serial.readStringUntil('\\n')).c_str())" : "bt_serial.parseFloat()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.bluetooth_read_byte = function() {
        setupBluetooth();
        return ["bt_serial.read()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.bluetooth_read_string = function() {
        setupBluetooth();
        return ["TRUE" == this.getFieldValue("NEWLINE") ? "bt_serial.readStringUntil('\\n')" : "bt_serial.readString()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.bluetooth_read_string_line = function() {
        setupBluetooth();
        return ["bt_serial.readStringUntil('\\n')", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.bluetooth_read_available = function() {
        setupBluetooth();
        return ["(bt_serial.available()>0)", Blockly.Arduino.ORDER_ATOMIC]
    };
}

// module.exports = init;